/* Shared product ordering for search pages, homepage suggestions and mega-menu suggestions. */
(() => {
  'use strict';
  const CAQA = window.CAQA = window.CAQA || {};
  // Edit this one list to change the resource-format order across all search surfaces.
  const formatOrder = [
    ['Learning and Assessment Kit', 'Learning and Assessment Resources', 'Learning & Assessment Resources'],
    ['Learner Resources'],
    ['Assessment Kit', 'Assessment Resources'],
    ['RPL Kit'], ['LLND Kit'], ['LLN Kit'], ['SCORM'], ['Learner Guide'],
    ['PowerPoint'], ['Session Plan'], ['Class Activity Book'], ['Self-Study Guide'],
    ['Unit Knowledge Guide'], ['Vocational Placement Kit'],
    ['Training and Assessment Strategy'], ['ERF Checklist'], ['Compliance Resources'],
    ['Policies and Procedures'], ['Forms'], ['ELICOS Resources'], ['Professional Development']
  ];
  const normalise = value => String(value || '').toLowerCase().replace(/&/g, ' and ').replace(/\s+/g, ' ').trim();
  const formatRank = new Map(formatOrder.flatMap((aliases, index) => aliases.map(alias => [normalise(alias), index])));
  const preorder = product => {
    if (typeof product.preorder === 'boolean') return product.preorder;
    const tags = Array.isArray(product.tags) ? product.tags : String(product.tags || '').split(',');
    if (tags.some(tag => /pre[-\s]?order/i.test(tag))) return true;
    if (tags.some(tag => /ready for sale/i.test(tag))) return false;
    return /pre[-\s]?order/i.test([product.title, product.featured_image, product.image].join(' '));
  };
  const ready = product => {
    if(typeof product.ready==='boolean')return product.ready;
    const tags=Array.isArray(product.tags)?product.tags:String(product.tags||'').split(',');
    return tags.some(tag=>/^ready for sale$/i.test(tag.trim()));
  };
  const statusLabel = product => preorder(product)?'Pre-order':product.available===false?'Currently unavailable':ready(product)?'Ready for sale':'Confirm delivery with CAQA';
  const codeOf = product => String(product.title||'').match(/\b(?:[A-Z]{2,8}\d{3,8}[A-Z]{0,2}|\d{5}[A-Z]{3})\b/i)?.[0]||'';
  const statusRank = product => product.object_type && product.object_type !== 'product' ? 4 : preorder(product) ? 3 : product.available === false ? 2 : ready(product) ? 0 : 1;
  const typeRank = product => formatRank.get(normalise(product.type || product.product_type)) ?? formatOrder.length;
  const collator=new Intl.Collator('en',{numeric:true,sensitivity:'base'});
  function rank(items, sort = 'relevance') {
    return items.map((item, index) => ({ item, index,code:codeOf(item),status:statusRank(item),format:typeRank(item),type:normalise(item.type) })).sort((a, b) => {
      const availability = a.status - b.status;
      if (availability && sort === 'relevance') return availability;
      if(sort==='code-ascending'||sort==='code-descending'){
        const aCode=a.code,bCode=b.code;
        if(!aCode!==!bCode)return aCode?-1:1;
        const difference=collator.compare(aCode,bCode);
        if(difference)return difference*(sort==='code-descending'?-1:1);
      }
      if (sort === 'price-ascending' || sort === 'price-descending') {
        const price = (Number(a.item.price) || 0) - (Number(b.item.price) || 0);
        if (price) return price * (sort === 'price-descending' ? -1 : 1);
      }
      if (sort === 'title-ascending' || sort === 'title-descending') {
        const title = collator.compare(String(a.item.title),String(b.item.title));
        if (title) return title * (sort === 'title-descending' ? -1 : 1);
      }
      const format = a.format - b.format;
      if (format) return format;
      // Keep unknown formats together, and Shopify relevance within each known format.
      if (a.format === formatOrder.length) {
        const type = collator.compare(a.type,b.type);
        if (type) return type;
      }
      const code=collator.compare(a.code,b.code);
      return code || collator.compare(String(a.item.title),String(b.item.title)) || a.index-b.index;
    }).map(record => record.item);
  }
  CAQA.searchPriority = { rank, preorder, ready, statusLabel, statusRank, typeRank, formatOrder };
})();
